<app-disclaimer></app-disclaimer>

<!-- German Practice Banner -->
<section class="py-3 py-md-4">
  <div class="container">
    <div class="card border-0 shadow-sm" style="background: linear-gradient(135deg, #FFCC00 0%, #FFD700 100%);">
      <div class="card-body py-3 py-md-4 px-3 px-md-4">
        <div class="row align-items-center g-3">
          <div class="col-12 col-md-8">
            <h5 class="fw-bold mb-1">{{ 'landing.deutsch.title' | transloco }}</h5>
            <p class="mb-0 small">{{ 'landing.deutsch.subtitle' | transloco }}</p>
          </div>
          <div class="col-12 col-md-4 text-md-end">
            <a routerLink="/learn-deutsch" class="btn btn-dark fw-semibold">
              <i class="bi bi-play-fill me-1"></i>{{ 'landing.deutsch.cta' | transloco }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Hero -->
<section class="py-3 py-lg-5 bg-primary bg-gradient text-white">
  <div class="container">
    <div class="row align-items-center g-5">
      <div class="col-lg-6 text-center text-lg-start">
        <h1 class="fw-bold mb-2 mb-lg-3" style="font-size: clamp(1.1rem, 5vw, 3.5rem);">{{ 'landing.hero.title' | transloco }}</h1>
        <p class="mb-2 mb-lg-3 opacity-90 d-none d-lg-block" style="font-size: clamp(0.8rem, 2.5vw, 1.25rem);">{{ 'landing.hero.subtitle' | transloco }}</p>
        <p class="mb-3 mb-lg-4 opacity-75 d-none d-lg-block">{{ 'landing.hero.description' | transloco }}</p>
        <div class="d-flex gap-2 justify-content-center justify-content-lg-start">
          @if (authenticated) {
            <a routerLink="/word/list" class="btn btn-light btn-sm px-2 px-lg-4 fw-semibold" style="font-size: clamp(0.75rem, 2.5vw, 1rem);">{{ 'landing.hero.myWords' | transloco }}</a>
            <a routerLink="/flashcard" class="btn btn-outline-light btn-sm px-2 px-lg-4 fw-semibold" style="font-size: clamp(0.75rem, 2.5vw, 1rem);">{{ 'landing.hero.flashcards' | transloco }}</a>
          } @else {
            <a routerLink="/register" class="btn btn-light btn-sm px-2 px-lg-4 fw-semibold" style="font-size: clamp(0.75rem, 2.5vw, 1rem);">{{ 'landing.hero.getStarted' | transloco }}</a>
            <a routerLink="/demo" class="btn btn-outline-light btn-sm px-2 px-lg-4 fw-semibold" style="font-size: clamp(0.75rem, 2.5vw, 1rem);">{{ 'landing.hero.tryDemo' | transloco }}</a>
          }
        </div>
        @if (!authenticated) {
          <p class="mt-2 mt-lg-3 mb-0 small opacity-75">{{ 'landing.hero.haveAccount' | transloco }} <a (click)="login()" role="button" class="text-white fw-semibold" style="cursor: pointer; text-decoration: underline;">{{ 'landing.hero.logIn' | transloco }}</a></p>
          <p class="mb-0 small opacity-50"><a (click)="forgotPassword()" role="button" class="text-white" style="cursor: pointer; text-decoration: underline;">{{ 'landing.hero.forgotPassword' | transloco }}</a></p>
        }
      </div>
      <div class="col-lg-6 text-center position-relative d-none d-lg-block" style="height: 350px;">
        @for (image of images; track image) {
          <img [src]="image"
               class="img-fluid rounded shadow position-absolute top-50 start-50 translate-middle"
               style="max-height: 350px; transition: opacity 1s ease-in-out;"
               [style.opacity]="image === images[currentIndex] ? 1 : 0"
               alt="Vocabulary illustration"
               loading="lazy">
        }
      </div>
    </div>
  </div>
</section>

<!-- Features -->
<section class="py-3 py-md-5">
  <div class="container">
    <h2 class="text-center fw-bold mb-2">{{ 'landing.features.title' | transloco }}</h2>
    <p class="text-center text-body-secondary mb-3 mb-md-5">{{ 'landing.features.subtitle' | transloco }}</p>
    <div class="row g-2 g-md-4">
      <div class="col-4">
        <div class="card shadow-sm border-0 bg-light text-center">
          <div class="card-body py-2 py-md-4 px-2 px-md-3 feature-toggle"
               data-bs-toggle="collapse" data-bs-target="#organizeDesc" aria-expanded="false">
            <div class="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-1 mb-md-3" style="width: clamp(40px, 8vw, 64px); height: clamp(40px, 8vw, 64px);">
              <i class="bi bi-book-half text-primary" style="font-size: clamp(1rem, 3vw, 1.5rem);"></i>
            </div>
            <h6 class="fw-semibold mb-0">{{ 'landing.features.organize.title' | transloco }}</h6>
            <i class="bi bi-chevron-down chevron d-md-none small text-body-secondary"></i>
          </div>
          <div class="collapse d-md-block px-2 pb-2" id="organizeDesc">
            <p class="text-body-secondary mb-0 small">{{ 'landing.features.organize.description' | transloco }}</p>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card shadow-sm border-0 text-center" style="background: rgba(25, 135, 84, 0.06);">
          <div class="card-body py-2 py-md-4 px-2 px-md-3 feature-toggle"
               data-bs-toggle="collapse" data-bs-target="#learnDesc" aria-expanded="false">
            <div class="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-1 mb-md-3" style="width: clamp(40px, 8vw, 64px); height: clamp(40px, 8vw, 64px);">
              <i class="bi bi-lightning-charge text-success" style="font-size: clamp(1rem, 3vw, 1.5rem);"></i>
            </div>
            <h6 class="fw-semibold mb-0">{{ 'landing.features.learn.title' | transloco }}</h6>
            <i class="bi bi-chevron-down chevron d-md-none small text-body-secondary"></i>
          </div>
          <div class="collapse d-md-block px-2 pb-2" id="learnDesc">
            <p class="text-body-secondary mb-1 small">{{ 'landing.features.learn.description' | transloco }}</p>
            @if (authenticated) {
              <a routerLink="/flashcard" class="small fw-semibold text-success">{{ 'landing.features.learn.practiceNow' | transloco }}</a>
            } @else {
              <a routerLink="/demo" class="small fw-semibold text-success">{{ 'landing.features.learn.tryDemo' | transloco }}</a>
            }
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card shadow-sm border-0 text-center" style="background: rgba(220, 53, 69, 0.06);">
          <div class="card-body py-2 py-md-4 px-2 px-md-3 feature-toggle"
               data-bs-toggle="collapse" data-bs-target="#growDesc" aria-expanded="false">
            <div class="bg-danger bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-1 mb-md-3" style="width: clamp(40px, 8vw, 64px); height: clamp(40px, 8vw, 64px);">
              <i class="bi bi-globe text-danger" style="font-size: clamp(1rem, 3vw, 1.5rem);"></i>
            </div>
            <h6 class="fw-semibold mb-0">{{ 'landing.features.grow.title' | transloco }}</h6>
            <i class="bi bi-chevron-down chevron d-md-none small text-body-secondary"></i>
          </div>
          <div class="collapse d-md-block px-2 pb-2" id="growDesc">
            <p class="text-body-secondary mb-0 small">{{ 'landing.features.grow.description' | transloco }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
@if (!authenticated) {
<section class="py-5 bg-light">
  <div class="container text-center">
    <h2 class="fw-bold mb-3">{{ 'landing.cta.title' | transloco }}</h2>
    <p class="text-body-secondary mb-4">{{ 'landing.cta.subtitle' | transloco }}</p>
    <a routerLink="/register" class="btn btn-primary btn-lg px-5">{{ 'landing.cta.createAccount' | transloco }}</a>
  </div>
</section>
}
